export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET';

export const GET_MY_BUSINESS_REQUEST = 'GET_MY_BUSINESS_REQUEST';
export const GET_MY_BUSINESS_SUCCESS = 'GET_MY_BUSINESS_SUCCESS';
export const GET_MY_BUSINESS_FAIL = 'GET_MY_BUSINESS_FAIL';
export const GET_MY_BUSINESS_RESET = 'GET_MY_BUSINESS_RESET';

export const TWO_FACTOR_AUTH_REQUEST = 'TWO_FACTOR_AUTH_REQUEST';
export const TWO_FACTOR_AUTH_SUCCESS = 'TWO_FACTOR_AUTH_SUCCESS';
export const TWO_FACTOR_AUTH_FAIL = 'TWO_FACTOR_AUTH_FAIL';

export const SET_VIEW_ONLY = 'SET_VIEW_ONLY';

export const ACCOUNT_DELETE_REQUEST = "ACCOUNT_DELETE_REQUEST";
export const ACCOUNT_DELETE_SUCCESS = "ACCOUNT_DELETE_SUCCESS";
export const ACCOUNT_DELETE_FAIL = "ACCOUNT_DELETE_FAIL";
export const ACCOUNT_DELETE_RESET = "ACCOUNT_DELETE_RESET";

export const ASSIGNED_ROLES_REQUEST = "ASSIGNED_ROLES_REQUEST";
export const ASSIGNED_ROLES_SUCCESS = "ASSIGNED_ROLES_SUCCESS";
export const ASSIGNED_ROLES_FAIL = "ASSIGNED_ROLES_FAIL";
export const ASSIGNED_ROLES_RESET = "ASSIGNED_ROLES_RESET";

export const DELETE_ROLE_ASSIGNMENT_REQUEST = "DELETE_ROLE_ASSIGNMENT_REQUEST";
export const DELETE_ROLE_ASSIGNMENT_SUCCESS = "DELETE_ROLE_ASSIGNMENT_SUCCESS";
export const DELETE_ROLE_ASSIGNMENT_FAIL = "DELETE_ROLE_ASSIGNMENT_FAIL";
export const DELETE_ROLE_ASSIGNMENT_RESET = "DELETE_ROLE_ASSIGNMENT_RESET";

// CUSTOMER CONSTANTS
export const CUSTOMER_LIST_REQUEST = "CUSTOMER_LIST_REQUEST";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_FAIL = "CUSTOMER_LIST_FAIL";
export const CUSTOMER_LIST_RESET = "CUSTOMER_LIST_RESET";

export const CUSTOMER_GET_ALL_REQUEST = "CUSTOMER_GET_ALL_REQUEST";
export const CUSTOMER_GET_ALL_SUCCESS = "CUSTOMER_GET_ALL_SUCCESS";
export const CUSTOMER_GET_ALL_FAIL = "CUSTOMER_GET_ALL_FAIL";

export const CUSTOMER_DETAILS_REQUEST = "CUSTOMER_DETAILS_REQUEST";
export const CUSTOMER_DETAILS_SUCCESS = "CUSTOMER_DETAILS_SUCCESS";
export const CUSTOMER_DETAILS_FAIL = "CUSTOMER_DETAILS_FAIL";
export const CUSTOMER_DETAILS_RESET = "CUSTOMER_DETAILS_RESET";

export const CUSTOMER_CREATE_REQUEST = "CUSTOMER_CREATE_REQUEST";
export const CUSTOMER_CREATE_SUCCESS = "CUSTOMER_CREATE_SUCCESS";
export const CUSTOMER_CREATE_FAIL = "CUSTOMER_CREATE_FAIL";
export const CUSTOMER_CREATE_RESET = "CUSTOMER_CREATE_RESET";

export const CUSTOMER_UPDATE_REQUEST = "CUSTOMER_UPDATE_REQUEST";
export const CUSTOMER_UPDATE_SUCCESS = "CUSTOMER_UPDATE_SUCCESS";
export const CUSTOMER_UPDATE_FAIL = "CUSTOMER_UPDATE_FAIL";
export const CUSTOMER_UPDATE_RESET = "CUSTOMER_UPDATE_RESET";


export const PRODUCTS_PAGED_REQUEST = 'PRODUCTS_PAGED_REQUEST';
export const PRODUCTS_PAGED_SUCCESS = 'PRODUCTS_PAGED_SUCCESS';
export const PRODUCTS_PAGED_FAIL = 'PRODUCTS_PAGED_FAIL';

export const PRODUCTS_ALL_REQUEST = 'PRODUCTS_ALL_REQUEST';
export const PRODUCTS_ALL_SUCCESS = 'PRODUCTS_ALL_SUCCESS';
export const PRODUCTS_ALL_FAIL = 'PRODUCTS_ALL_FAIL';

export const PRODUCT_DETAILS_REQUEST = 'PRODUCT_DETAILS_REQUEST';
export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_FAIL = 'PRODUCT_DETAILS_FAIL';

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';
export const PRODUCT_CREATE_FAIL = 'PRODUCT_CREATE_FAIL';
export const PRODUCT_CREATE_RESET = 'PRODUCT_CREATE_RESET';

export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_UPDATE_FAIL = 'PRODUCT_UPDATE_FAIL';
export const PRODUCT_UPDATE_RESET = 'PRODUCT_UPDATE_RESET';

export const PRODUCT_DELETE_REQUEST = 'PRODUCT_DELETE_REQUEST';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_FAIL = 'PRODUCT_DELETE_FAIL';

export const PRODUCT_UPDATE_PRICING_REQUEST = 'PRODUCT_UPDATE_PRICING_REQUEST';
export const PRODUCT_UPDATE_PRICING_SUCCESS = 'PRODUCT_UPDATE_PRICING_SUCCESS';
export const PRODUCT_UPDATE_PRICING_FAIL = 'PRODUCT_UPDATE_PRICING_FAIL';

//
// Images
export const PRODUCT_IMAGES_REQUEST = 'PRODUCT_IMAGES_REQUEST';
export const PRODUCT_IMAGES_SUCCESS = 'PRODUCT_IMAGES_SUCCESS';
export const PRODUCT_IMAGES_FAIL = 'PRODUCT_IMAGES_FAIL';

export const PRODUCT_IMAGE_CREATE_REQUEST = 'PRODUCT_IMAGE_CREATE_REQUEST';
export const PRODUCT_IMAGE_CREATE_SUCCESS = 'PRODUCT_IMAGE_CREATE_SUCCESS';
export const PRODUCT_IMAGE_CREATE_FAIL = 'PRODUCT_IMAGE_CREATE_FAIL';

export const PRODUCT_IMAGE_UPDATE_REQUEST = 'PRODUCT_IMAGE_UPDATE_REQUEST';
export const PRODUCT_IMAGE_UPDATE_SUCCESS = 'PRODUCT_IMAGE_UPDATE_SUCCESS';
export const PRODUCT_IMAGE_UPDATE_FAIL = 'PRODUCT_IMAGE_UPDATE_FAIL';

export const PRODUCT_IMAGE_DELETE_REQUEST = 'PRODUCT_IMAGE_DELETE_REQUEST';
export const PRODUCT_IMAGE_DELETE_SUCCESS = 'PRODUCT_IMAGE_DELETE_SUCCESS';
export const PRODUCT_IMAGE_DELETE_FAIL = 'PRODUCT_IMAGE_DELETE_FAIL';

//
// Variants
export const PRODUCT_VARIANTS_REQUEST = 'PRODUCT_VARIANTS_REQUEST';
export const PRODUCT_VARIANTS_SUCCESS = 'PRODUCT_VARIANTS_SUCCESS';
export const PRODUCT_VARIANTS_FAIL = 'PRODUCT_VARIANTS_FAIL';

export const PRODUCT_VARIANT_CREATE_REQUEST = 'PRODUCT_VARIANT_CREATE_REQUEST';
export const PRODUCT_VARIANT_CREATE_SUCCESS = 'PRODUCT_VARIANT_CREATE_SUCCESS';
export const PRODUCT_VARIANT_CREATE_FAIL = 'PRODUCT_VARIANT_CREATE_FAIL';

export const PRODUCT_VARIANT_UPDATE_REQUEST = 'PRODUCT_VARIANT_UPDATE_REQUEST';
export const PRODUCT_VARIANT_UPDATE_SUCCESS = 'PRODUCT_VARIANT_UPDATE_SUCCESS';
export const PRODUCT_VARIANT_UPDATE_FAIL = 'PRODUCT_VARIANT_UPDATE_FAIL';

export const PRODUCT_VARIANT_DELETE_REQUEST = 'PRODUCT_VARIANT_DELETE_REQUEST';
export const PRODUCT_VARIANT_DELETE_SUCCESS = 'PRODUCT_VARIANT_DELETE_SUCCESS';
export const PRODUCT_VARIANT_DELETE_FAIL = 'PRODUCT_VARIANT_DELETE_FAIL';

//
// Pricing rules
export const PRODUCT_PRICING_RULES_REQUEST = 'PRODUCT_PRICING_RULES_REQUEST';
export const PRODUCT_PRICING_RULES_SUCCESS = 'PRODUCT_PRICING_RULES_SUCCESS';
export const PRODUCT_PRICING_RULES_FAIL = 'PRODUCT_PRICING_RULES_FAIL';

export const PRODUCT_PRICING_RULE_CREATE_REQUEST = 'PRODUCT_PRICING_RULE_CREATE_REQUEST';
export const PRODUCT_PRICING_RULE_CREATE_SUCCESS = 'PRODUCT_PRICING_RULE_CREATE_SUCCESS';
export const PRODUCT_PRICING_RULE_CREATE_FAIL = 'PRODUCT_PRICING_RULE_CREATE_FAIL';

export const PRODUCT_PRICING_RULE_UPDATE_REQUEST = 'PRODUCT_PRICING_RULE_UPDATE_REQUEST';
export const PRODUCT_PRICING_RULE_UPDATE_SUCCESS = 'PRODUCT_PRICING_RULE_UPDATE_SUCCESS';
export const PRODUCT_PRICING_RULE_UPDATE_FAIL = 'PRODUCT_PRICING_RULE_UPDATE_FAIL';

export const PRODUCT_PRICING_RULE_DELETE_REQUEST = 'PRODUCT_PRICING_RULE_DELETE_REQUEST';
export const PRODUCT_PRICING_RULE_DELETE_SUCCESS = 'PRODUCT_PRICING_RULE_DELETE_SUCCESS';
export const PRODUCT_PRICING_RULE_DELETE_FAIL = 'PRODUCT_PRICING_RULE_DELETE_FAIL';

// PODCASTS
export const PODCAST_LIST_REQUEST = "PODCAST_LIST_REQUEST";
export const PODCAST_LIST_SUCCESS = "PODCAST_LIST_SUCCESS";
export const PODCAST_LIST_FAIL = "PODCAST_LIST_FAIL";
export const PODCAST_LIST_RESET = "PODCAST_LIST_RESET";

export const PODCAST_DETAILS_REQUEST = "PODCAST_DETAILS_REQUEST";
export const PODCAST_DETAILS_SUCCESS = "PODCAST_DETAILS_SUCCESS";
export const PODCAST_DETAILS_FAIL = "PODCAST_DETAILS_FAIL";

export const PODCAST_CREATE_REQUEST = "PODCAST_CREATE_REQUEST";
export const PODCAST_CREATE_SUCCESS = "PODCAST_CREATE_SUCCESS";
export const PODCAST_CREATE_FAIL = "PODCAST_CREATE_FAIL";
export const PODCAST_CREATE_RESET = "PODCAST_CREATE_RESET";

export const PODCAST_UPDATE_REQUEST = "PODCAST_UPDATE_REQUEST";
export const PODCAST_UPDATE_SUCCESS = "PODCAST_UPDATE_SUCCESS";
export const PODCAST_UPDATE_FAIL = "PODCAST_UPDATE_FAIL";
export const PODCAST_UPDATE_RESET = "PODCAST_UPDATE_RESET";

export const PODCAST_DELETE_REQUEST = "PODCAST_DELETE_REQUEST";
export const PODCAST_DELETE_SUCCESS = "PODCAST_DELETE_SUCCESS";
export const PODCAST_DELETE_FAIL = "PODCAST_DELETE_FAIL";
export const PODCAST_DELETE_RESET = "PODCAST_DELETE_RESET";

export const PODCAST_STATS_REQUEST = 'PODCAST_STATS_REQUEST';
export const PODCAST_STATS_SUCCESS = 'PODCAST_STATS_SUCCESS';
export const PODCAST_STATS_FAIL = 'PODCAST_STATS_FAIL';
export const PODCAST_STATS_RESET = 'PODCAST_STATS_RESET';

// PAYMENT METHOD CONSTANTS
export const PAYMENT_METHOD_LIST_REQUEST = "PAYMENT_METHOD_LIST_REQUEST";
export const PAYMENT_METHOD_LIST_SUCCESS = "PAYMENT_METHOD_LIST_SUCCESS";
export const PAYMENT_METHOD_LIST_FAIL = "PAYMENT_METHOD_LIST_FAIL";

export const PAYMENT_METHOD_CODES_REQUEST = "PAYMENT_METHOD_CODES_REQUEST";
export const PAYMENT_METHOD_CODES_SUCCESS = "PAYMENT_METHOD_CODES_SUCCESS";
export const PAYMENT_METHOD_CODES_FAIL = "PAYMENT_METHOD_CODES_FAIL";

export const PAYMENT_METHOD_PAGED_REQUEST = "PAYMENT_METHOD_PAGED_REQUEST";
export const PAYMENT_METHOD_PAGED_SUCCESS = "PAYMENT_METHOD_PAGED_SUCCESS";
export const PAYMENT_METHOD_PAGED_FAIL = "PAYMENT_METHOD_PAGED_FAIL";

export const PAYMENT_METHOD_DETAILS_REQUEST = "PAYMENT_METHOD_DETAILS_REQUEST";
export const PAYMENT_METHOD_DETAILS_SUCCESS = "PAYMENT_METHOD_DETAILS_SUCCESS";
export const PAYMENT_METHOD_DETAILS_FAIL = "PAYMENT_METHOD_DETAILS_FAIL";

export const PAYMENT_METHOD_CREATE_REQUEST = "PAYMENT_METHOD_CREATE_REQUEST";
export const PAYMENT_METHOD_CREATE_SUCCESS = "PAYMENT_METHOD_CREATE_SUCCESS";
export const PAYMENT_METHOD_CREATE_FAIL = "PAYMENT_METHOD_CREATE_FAIL";
export const PAYMENT_METHOD_CREATE_RESET = "PAYMENT_METHOD_CREATE_RESET";

export const PAYMENT_METHOD_UPDATE_REQUEST = "PAYMENT_METHOD_UPDATE_REQUEST";
export const PAYMENT_METHOD_UPDATE_SUCCESS = "PAYMENT_METHOD_UPDATE_SUCCESS";
export const PAYMENT_METHOD_UPDATE_FAIL = "PAYMENT_METHOD_UPDATE_FAIL";
export const PAYMENT_METHOD_UPDATE_RESET = "PAYMENT_METHOD_UPDATE_RESET";

export const PAYMENT_METHOD_DELETE_REQUEST = "PAYMENT_METHOD_DELETE_REQUEST";
export const PAYMENT_METHOD_DELETE_SUCCESS = "PAYMENT_METHOD_DELETE_SUCCESS";
export const PAYMENT_METHOD_DELETE_FAIL = "PAYMENT_METHOD_DELETE_FAIL";

// FEES CONSTANTS
export const FEE_LIST_REQUEST = "FEE_LIST_REQUEST";
export const FEE_LIST_SUCCESS = "FEE_LIST_SUCCESS";
export const FEE_LIST_FAIL = "FEE_LIST_FAIL";

export const FEE_PAGED_REQUEST = "FEE_PAGED_REQUEST";
export const FEE_PAGED_SUCCESS = "FEE_PAGED_SUCCESS";
export const FEE_PAGED_FAIL = "FEE_PAGED_FAIL";

export const FEE_DETAILS_REQUEST = "FEE_DETAILS_REQUEST";
export const FEE_DETAILS_SUCCESS = "FEE_DETAILS_SUCCESS";
export const FEE_DETAILS_FAIL = "FEE_DETAILS_FAIL";

export const FEE_CREATE_REQUEST = "FEE_CREATE_REQUEST";
export const FEE_CREATE_SUCCESS = "FEE_CREATE_SUCCESS";
export const FEE_CREATE_FAIL = "FEE_CREATE_FAIL";
export const FEE_CREATE_RESET = "FEE_CREATE_RESET";

export const FEE_UPDATE_REQUEST = "FEE_UPDATE_REQUEST";
export const FEE_UPDATE_SUCCESS = "FEE_UPDATE_SUCCESS";
export const FEE_UPDATE_FAIL = "FEE_UPDATE_FAIL";
export const FEE_UPDATE_RESET = "FEE_UPDATE_RESET";

export const FEE_DELETE_REQUEST = "FEE_DELETE_REQUEST";
export const FEE_DELETE_SUCCESS = "FEE_DELETE_SUCCESS";
export const FEE_DELETE_FAIL = "FEE_DELETE_FAIL";

// PAYNOW CREDENTIALS
export const PAYNOW_CREDENTIALS_PAGED_REQUEST = "PAYNOW_CREDENTIALS_PAGED_REQUEST";
export const PAYNOW_CREDENTIALS_PAGED_SUCCESS = "PAYNOW_CREDENTIALS_PAGED_SUCCESS";
export const PAYNOW_CREDENTIALS_PAGED_FAIL = "PAYNOW_CREDENTIALS_PAGED_FAIL";

export const PAYNOW_CREDENTIAL_CREATE_REQUEST = "PAYNOW_CREDENTIAL_CREATE_REQUEST";
export const PAYNOW_CREDENTIAL_CREATE_SUCCESS = "PAYNOW_CREDENTIAL_CREATE_SUCCESS";
export const PAYNOW_CREDENTIAL_CREATE_FAIL = "PAYNOW_CREDENTIAL_CREATE_FAIL";
export const PAYNOW_CREDENTIAL_CREATE_RESET = "PAYNOW_CREDENTIAL_CREATE_RESET";

export const PAYNOW_CREDENTIAL_UPDATE_REQUEST = "PAYNOW_CREDENTIAL_UPDATE_REQUEST";
export const PAYNOW_CREDENTIAL_UPDATE_SUCCESS = "PAYNOW_CREDENTIAL_UPDATE_SUCCESS";
export const PAYNOW_CREDENTIAL_UPDATE_FAIL = "PAYNOW_CREDENTIAL_UPDATE_FAIL";
export const PAYNOW_CREDENTIAL_UPDATE_RESET = "PAYNOW_CREDENTIAL_UPDATE_RESET";

export const PAYNOW_CREDENTIAL_DELETE_REQUEST = "PAYNOW_CREDENTIAL_DELETE_REQUEST";
export const PAYNOW_CREDENTIAL_DELETE_SUCCESS = "PAYNOW_CREDENTIAL_DELETE_SUCCESS";
export const PAYNOW_CREDENTIAL_DELETE_FAIL = "PAYNOW_CREDENTIAL_DELETE_FAIL";



// ************ File Management Constants ************

// Upload File
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';
export const UPLOAD_FILE_RESET = 'UPLOAD_FILE_RESET';

// Delete File
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAIL = 'DELETE_FILE_FAIL';
export const DELETE_FILE_RESET = 'DELETE_FILE_RESET';

// Create Directory
export const CREATE_DIRECTORY_REQUEST = 'CREATE_DIRECTORY_REQUEST';
export const CREATE_DIRECTORY_SUCCESS = 'CREATE_DIRECTORY_SUCCESS';
export const CREATE_DIRECTORY_FAIL = 'CREATE_DIRECTORY_FAIL';
export const CREATE_DIRECTORY_RESET = 'CREATE_DIRECTORY_RESET';

export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAIL = 'DOWNLOAD_FILE_FAIL';
export const DOWNLOAD_FILE_RESET = 'DOWNLOAD_FILE_RESET';

// PRODUCT CATEGORIES
export const PRODUCT_CATEGORY_LIST_REQUEST = "PRODUCT_CATEGORY_LIST_REQUEST";
export const PRODUCT_CATEGORY_LIST_SUCCESS = "PRODUCT_CATEGORY_LIST_SUCCESS";
export const PRODUCT_CATEGORY_LIST_FAIL = "PRODUCT_CATEGORY_LIST_FAIL";

export const PRODUCT_CATEGORY_PAGED_REQUEST = "PRODUCT_CATEGORY_PAGED_REQUEST";
export const PRODUCT_CATEGORY_PAGED_SUCCESS = "PRODUCT_CATEGORY_PAGED_SUCCESS";
export const PRODUCT_CATEGORY_PAGED_FAIL = "PRODUCT_CATEGORY_PAGED_FAIL";

export const PRODUCT_CATEGORY_DETAILS_REQUEST = "PRODUCT_CATEGORY_DETAILS_REQUEST";
export const PRODUCT_CATEGORY_DETAILS_SUCCESS = "PRODUCT_CATEGORY_DETAILS_SUCCESS";
export const PRODUCT_CATEGORY_DETAILS_FAIL = "PRODUCT_CATEGORY_DETAILS_FAIL";

export const PRODUCT_CATEGORY_CREATE_REQUEST = "PRODUCT_CATEGORY_CREATE_REQUEST";
export const PRODUCT_CATEGORY_CREATE_SUCCESS = "PRODUCT_CATEGORY_CREATE_SUCCESS";
export const PRODUCT_CATEGORY_CREATE_FAIL = "PRODUCT_CATEGORY_CREATE_FAIL";
export const PRODUCT_CATEGORY_CREATE_RESET = "PRODUCT_CATEGORY_CREATE_RESET";

export const PRODUCT_CATEGORY_UPDATE_REQUEST = "PRODUCT_CATEGORY_UPDATE_REQUEST";
export const PRODUCT_CATEGORY_UPDATE_SUCCESS = "PRODUCT_CATEGORY_UPDATE_SUCCESS";
export const PRODUCT_CATEGORY_UPDATE_FAIL = "PRODUCT_CATEGORY_UPDATE_FAIL";
export const PRODUCT_CATEGORY_UPDATE_RESET = "PRODUCT_CATEGORY_UPDATE_RESET";

export const PRODUCT_CATEGORY_DELETE_REQUEST = "PRODUCT_CATEGORY_DELETE_REQUEST";
export const PRODUCT_CATEGORY_DELETE_SUCCESS = "PRODUCT_CATEGORY_DELETE_SUCCESS";
export const PRODUCT_CATEGORY_DELETE_FAIL = "PRODUCT_CATEGORY_DELETE_FAIL";



// Products
export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const CREATE_PRODUCT_RESET = "CREATE_PRODUCT_RESET";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";

export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAIL = "GET_PRODUCT_FAIL";
export const GET_PRODUCT_RESET = "GET_PRODUCT_RESET";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";

export const GET_PAGED_PRODUCTS_REQUEST = "GET_PAGED_PRODUCTS_REQUEST";
export const GET_PAGED_PRODUCTS_SUCCESS = "GET_PAGED_PRODUCTS_SUCCESS";
export const GET_PAGED_PRODUCTS_FAIL = "GET_PAGED_PRODUCTS_FAIL";
export const GET_PAGED_PRODUCTS_RESET = "GET_PAGED_PRODUCTS_RESET";

// ----------------- PRODUCTS BY SUPPLIER -----------------
export const GET_PRODUCTS_BY_SUPPLIER_REQUEST = "GET_PRODUCTS_BY_SUPPLIER_REQUEST";
export const GET_PRODUCTS_BY_SUPPLIER_SUCCESS = "GET_PRODUCTS_BY_SUPPLIER_SUCCESS";
export const GET_PRODUCTS_BY_SUPPLIER_FAIL = "GET_PRODUCTS_BY_SUPPLIER_FAIL";
export const GET_PRODUCTS_BY_SUPPLIER_RESET = "GET_PRODUCTS_BY_SUPPLIER_RESET";

// ----------------- PRODUCTS BY SUBCATEGORY -----------------
export const GET_PRODUCTS_BY_SUBCATEGORY_REQUEST = "GET_PRODUCTS_BY_SUBCATEGORY_REQUEST";
export const GET_PRODUCTS_BY_SUBCATEGORY_SUCCESS = "GET_PRODUCTS_BY_SUBCATEGORY_SUCCESS";
export const GET_PRODUCTS_BY_SUBCATEGORY_FAIL = "GET_PRODUCTS_BY_SUBCATEGORY_FAIL";
export const GET_PRODUCTS_BY_SUBCATEGORY_RESET = "GET_PRODUCTS_BY_SUBCATEGORY_RESET";

// Stock Overview
export const GET_STOCK_OVERVIEW_REQUEST = "GET_STOCK_OVERVIEW_REQUEST";
export const GET_STOCK_OVERVIEW_SUCCESS = "GET_STOCK_OVERVIEW_SUCCESS";
export const GET_STOCK_OVERVIEW_FAIL = "GET_STOCK_OVERVIEW_FAIL";

// Stock Summary
export const GET_STOCK_SUMMARY_REQUEST = "GET_STOCK_SUMMARY_REQUEST";
export const GET_STOCK_SUMMARY_SUCCESS = "GET_STOCK_SUMMARY_SUCCESS";
export const GET_STOCK_SUMMARY_FAIL = "GET_STOCK_SUMMARY_FAIL";

// Update Stock
export const UPDATE_PRODUCT_STOCK_REQUEST = "UPDATE_PRODUCT_STOCK_REQUEST";
export const UPDATE_PRODUCT_STOCK_SUCCESS = "UPDATE_PRODUCT_STOCK_SUCCESS";
export const UPDATE_PRODUCT_STOCK_FAIL = "UPDATE_PRODUCT_STOCK_FAIL";

// Refresh Stock Statuses
export const REFRESH_STOCK_STATUSES_REQUEST = "REFRESH_STOCK_STATUSES_REQUEST";
export const REFRESH_STOCK_STATUSES_SUCCESS = "REFRESH_STOCK_STATUSES_SUCCESS";
export const REFRESH_STOCK_STATUSES_FAIL = "REFRESH_STOCK_STATUSES_FAIL";


// ----------------- PRODUCTS BY CATEGORY -----------------
export const GET_PRODUCTS_BY_CATEGORY_REQUEST = "GET_PRODUCTS_BY_CATEGORY_REQUEST";
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS = "GET_PRODUCTS_BY_CATEGORY_SUCCESS";
export const GET_PRODUCTS_BY_CATEGORY_FAIL = "GET_PRODUCTS_BY_CATEGORY_FAIL";
export const GET_PRODUCTS_BY_CATEGORY_RESET = "GET_PRODUCTS_BY_CATEGORY_RESET";


export const GROUPS_LIST_REQUEST = 'GROUPS_LIST_REQUEST';
export const GROUPS_LIST_SUCCESS = 'GROUPS_LIST_SUCCESS';
export const GROUPS_LIST_FAIL = 'GROUPS_LIST_FAIL';
export const GROUPS_LIST_RESET = 'GROUPS_LIST_RESET';

export const GROUPS_UNPAGED_REQUEST = "GROUPS_UNPAGED_REQUEST";
export const GROUPS_UNPAGED_SUCCESS = "GROUPS_UNPAGED_SUCCESS";
export const GROUPS_UNPAGED_FAIL = "GROUPS_UNPAGED_FAIL";
export const GROUPS_UNPAGED_RESET = "GROUPS_UNPAGED_RESET";



export const ADMIN_GROUPS_LIST_REQUEST = 'ADMIN_GROUPS_LIST_REQUEST';
export const ADMIN_GROUPS_LIST_SUCCESS = 'ADMIN_GROUPS_LIST_SUCCESS';
export const ADMIN_GROUPS_LIST_FAIL = 'ADMIN_GROUPS_LIST_FAIL';
export const ADMIN_GROUPS_LIST_RESET = 'ADMIN_GROUPS_LIST_RESET';

export const GROUP_DETAILS_REQUEST = 'GROUP_DETAILS_REQUEST';
export const GROUP_DETAILS_SUCCESS = 'GROUP_DETAILS_SUCCESS';
export const GROUP_DETAILS_FAIL = 'GROUP_DETAILS_FAIL';
export const GROUP_DETAILS_RESET = 'GROUP_DETAILS_RESET';

export const GROUP_CREATE_REQUEST = 'GROUP_CREATE_REQUEST';
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS';
export const GROUP_CREATE_FAIL = 'GROUP_CREATE_FAIL';
export const GROUP_CREATE_RESET = 'GROUP_CREATE_RESET';

export const GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
export const GROUP_UPDATE_FAIL = 'GROUP_UPDATE_FAIL';
export const GROUP_UPDATE_RESET = 'GROUP_UPDATE_RESET';

export const GROUP_DELETE_REQUEST = 'GROUP_DELETE_REQUEST';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUP_DELETE_FAIL = 'GROUP_DELETE_FAIL';
export const GROUP_DELETE_RESET = 'GROUP_DELETE_RESET';

// Group Permissions Constants
export const GROUP_PERMISSIONS_LIST_REQUEST = 'GROUP_PERMISSIONS_LIST_REQUEST';
export const GROUP_PERMISSIONS_LIST_SUCCESS = 'GROUP_PERMISSIONS_LIST_SUCCESS';
export const GROUP_PERMISSIONS_LIST_FAIL = 'GROUP_PERMISSIONS_LIST_FAIL';
export const GROUP_PERMISSIONS_LIST_RESET = 'GROUP_PERMISSIONS_LIST_RESET';

export const GROUP_PERMISSIONS_ALL_REQUEST = 'GROUP_PERMISSIONS_ALL_REQUEST';
export const GROUP_PERMISSIONS_ALL_SUCCESS = 'GROUP_PERMISSIONS_ALL_SUCCESS';
export const GROUP_PERMISSIONS_ALL_FAIL = 'GROUP_PERMISSIONS_ALL_FAIL';
export const GROUP_PERMISSIONS_ALL_RESET = 'GROUP_PERMISSIONS_ALL_RESET';

export const GROUP_PERMISSION_CREATE_REQUEST = 'GROUP_PERMISSION_CREATE_REQUEST';
export const GROUP_PERMISSION_CREATE_SUCCESS = 'GROUP_PERMISSION_CREATE_SUCCESS';
export const GROUP_PERMISSION_CREATE_FAIL = 'GROUP_PERMISSION_CREATE_FAIL';
export const GROUP_PERMISSION_CREATE_RESET = 'GROUP_PERMISSION_CREATE_RESET';

// Bulk create
export const GROUP_PERMISSION_BULK_CREATE_REQUEST = 'GROUP_PERMISSION_BULK_CREATE_REQUEST';
export const GROUP_PERMISSION_BULK_CREATE_SUCCESS = 'GROUP_PERMISSION_BULK_CREATE_SUCCESS';
export const GROUP_PERMISSION_BULK_CREATE_FAIL = 'GROUP_PERMISSION_BULK_CREATE_FAIL';
export const GROUP_PERMISSION_BULK_CREATE_RESET = 'GROUP_PERMISSION_BULK_CREATE_RESET';

export const GROUP_PERMISSION_REVOKE_REQUEST = 'GROUP_PERMISSION_REVOKE_REQUEST';
export const GROUP_PERMISSION_REVOKE_SUCCESS = 'GROUP_PERMISSION_REVOKE_SUCCESS';
export const GROUP_PERMISSION_REVOKE_FAIL = 'GROUP_PERMISSION_REVOKE_FAIL';
export const GROUP_PERMISSION_REVOKE_RESET = 'GROUP_PERMISSION_REVOKE_RESET';

export const GROUP_PERMISSION_BULK_REVOKE_REQUEST = 'GROUP_PERMISSION_BULK_REVOKE_REQUEST';
export const GROUP_PERMISSION_BULK_REVOKE_SUCCESS = 'GROUP_PERMISSION_BULK_REVOKE_SUCCESS';
export const GROUP_PERMISSION_BULK_REVOKE_FAIL = 'GROUP_PERMISSION_BULK_REVOKE_FAIL';
export const GROUP_PERMISSION_BULK_REVOKE_RESET = 'GROUP_PERMISSION_BULK_REVOKE_RESET';

export const GROUP_PERMISSION_UNASSIGNED_REQUEST = 'GROUP_PERMISSION_UNASSIGNED_REQUEST';
export const GROUP_PERMISSION_UNASSIGNED_SUCCESS = 'GROUP_PERMISSION_UNASSIGNED_SUCCESS';
export const GROUP_PERMISSION_UNASSIGNED_FAIL = 'GROUP_PERMISSION_UNASSIGNED_FAIL';
export const GROUP_PERMISSION_UNASSIGNED_RESET = 'GROUP_PERMISSION_UNASSIGNED_RESET';

// Permissions
export const PERMISSIONS_LIST_REQUEST = 'PERMISSIONS_LIST_REQUEST';
export const PERMISSIONS_LIST_SUCCESS = 'PERMISSIONS_LIST_SUCCESS';
export const PERMISSIONS_LIST_FAIL = 'PERMISSIONS_LIST_FAIL';
export const PERMISSIONS_LIST_RESET = 'PERMISSIONS_LIST_RESET'; 

export const PERMISSIONS_ALL_REQUEST = 'PERMISSIONS_ALL_REQUEST';
export const PERMISSIONS_ALL_SUCCESS = 'PERMISSIONS_ALL_SUCCESS';
export const PERMISSIONS_ALL_FAIL = 'PERMISSIONS_ALL_FAIL';
export const PERMISSIONS_ALL_RESET = 'PERMISSIONS_ALL_RESET';

export const PERMISSION_DETAILS_REQUEST = 'PERMISSION_DETAILS_REQUEST';
export const PERMISSION_DETAILS_SUCCESS = 'PERMISSION_DETAILS_SUCCESS';
export const PERMISSION_DETAILS_FAIL = 'PERMISSION_DETAILS_FAIL';
export const PERMISSION_DETAILS_RESET = 'PERMISSION_DETAILS_RESET';

export const PERMISSIONS_CLIENT_ACCESSIBLE_REQUEST = 'PERMISSIONS_CLIENT_ACCESSIBLE_REQUEST';
export const PERMISSIONS_CLIENT_ACCESSIBLE_SUCCESS = 'PERMISSIONS_CLIENT_ACCESSIBLE_SUCCESS';
export const PERMISSIONS_CLIENT_ACCESSIBLE_FAIL = 'PERMISSIONS_CLIENT_ACCESSIBLE_FAIL';
export const PERMISSIONS_CLIENT_ACCESSIBLE_RESET = 'PERMISSIONS_CLIENT_ACCESSIBLE_RESET';

export const PERMISSIONS_CUSTOMER_ACCESSIBLE_REQUEST = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_REQUEST';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_SUCCESS = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_SUCCESS';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_FAIL = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_FAIL';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_RESET = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_RESET';

export const PERMISSION_CREATE_REQUEST = 'PERMISSION_CREATE_REQUEST';
export const PERMISSION_CREATE_SUCCESS = 'PERMISSION_CREATE_SUCCESS';
export const PERMISSION_CREATE_FAIL = 'PERMISSION_CREATE_FAIL';
export const PERMISSION_CREATE_RESET = 'PERMISSION_CREATE_RESET';

export const PERMISSION_BULK_CREATE_REQUEST = 'PERMISSION_BULK_CREATE_REQUEST';
export const PERMISSION_BULK_CREATE_SUCCESS = 'PERMISSION_BULK_CREATE_SUCCESS';
export const PERMISSION_BULK_CREATE_FAIL = 'PERMISSION_BULK_CREATE_FAIL';
export const PERMISSION_BULK_CREATE_RESET = 'PERMISSION_BULK_CREATE_RESET';

export const PERMISSION_UPDATE_REQUEST = 'PERMISSION_UPDATE_REQUEST';
export const PERMISSION_UPDATE_SUCCESS = 'PERMISSION_UPDATE_SUCCESS';
export const PERMISSION_UPDATE_FAIL = 'PERMISSION_UPDATE_FAIL';
export const PERMISSION_UPDATE_RESET = 'PERMISSION_UPDATE_RESET';

export const PERMISSION_DELETE_REQUEST = 'PERMISSION_DELETE_REQUEST';
export const PERMISSION_DELETE_SUCCESS = 'PERMISSION_DELETE_SUCCESS';
export const PERMISSION_DELETE_FAIL = 'PERMISSION_DELETE_FAIL';
export const PERMISSION_DELETE_RESET = 'PERMISSION_DELETE_RESET';



// For getAllUsersAction
export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';
export const USER_GET_ALL_RESET = 'USER_GET_ALL_RESET';
export const USER_DELETE_ALL_RESET = 'USER_DELETE_ALL_RESET';
export const USER_DELETE_ALL_REQUEST = 'USER_DELETE_ALL_REQUEST';
export const USER_DELETE_ALL_SUCCESS = 'USER_DELETE_ALL_SUCCESS';
export const USER_DELETE_ALL_FAIL = 'USER_DELETE_ALL_FAIL';

export const USER_DELETE = 'ORDER_DELETE';
export const USER_DELETE_FAIL = 'ORDER_DELETE_FAIL';
export const USER_DELETE_RESET = 'ORDER_DELETE_RESET';

// For viewUserDetailsAction
export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL';


//user update
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';

//reset user 
export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_FAIL = 'RESET_USER_PASSWORD_FAIL';
export const RESET_USER_PASSWORD_RESET = 'RESET_USER_PASSWORD_RESET';

export const VERIFY_ACCOUNT_REQUEST = 'VERIFY_ACCOUNT_REQUEST';
export const VERIFY_ACCOUNT_SUCCESS = 'VERIFY_ACCOUNT_SUCCESS';
export const VERIFY_ACCOUNT_FAIL = 'VERIFY_ACCOUNT_FAIL';
export const VERIFY_ACCOUNT_RESET = 'VERIFY_ACCOUNT_RESET';

export const CHANGE_USER_GROUP_REQUEST = "CHANGE_USER_GROUP_REQUEST";
export const CHANGE_USER_GROUP_SUCCESS = "CHANGE_USER_GROUP_SUCCESS";
export const CHANGE_USER_GROUP_FAIL = "CHANGE_USER_GROUP_FAIL";
export const CHANGE_USER_GROUP_RESET = "CHANGE_USER_GROUP_RESET";

export const CHANGE_USER_STATUS_REQUEST = "CHANGE_USER_STATUS_REQUEST";
export const CHANGE_USER_STATUS_SUCCESS = "CHANGE_USER_STATUS_SUCCESS";
export const CHANGE_USER_STATUS_FAIL = "CHANGE_USER_STATUS_FAIL";
export const CHANGE_USER_STATUS_RESET = "CHANGE_USER_STATUS_RESET";

// User Permissions
// List (paginated)
export const USER_PERMISSIONS_REQUEST = "USER_PERMISSIONS_REQUEST";
export const USER_PERMISSIONS_SUCCESS = "USER_PERMISSIONS_SUCCESS";
export const USER_PERMISSIONS_FAIL = "USER_PERMISSIONS_FAIL";
export const USER_PERMISSIONS_RESET = "USER_PERMISSIONS_RESET";

// List (all)
export const USER_PERMISSIONS_ALL_REQUEST = "USER_PERMISSIONS_ALL_REQUEST";
export const USER_PERMISSIONS_ALL_SUCCESS = "USER_PERMISSIONS_ALL_SUCCESS";
export const USER_PERMISSIONS_ALL_FAIL = "USER_PERMISSIONS_ALL_FAIL";
export const USER_PERMISSIONS_ALL_RESET = "USER_PERMISSIONS_ALL_RESET";

// Assign single
export const ASSIGN_PERMISSION_REQUEST = "ASSIGN_PERMISSION_REQUEST";
export const ASSIGN_PERMISSION_SUCCESS = "ASSIGN_PERMISSION_SUCCESS";
export const ASSIGN_PERMISSION_FAIL = "ASSIGN_PERMISSION_FAIL";
export const ASSIGN_PERMISSION_RESET = "ASSIGN_PERMISSION_RESET";

// Assign bulk
export const ASSIGN_BULK_PERMISSION_REQUEST = "ASSIGN_BULK_PERMISSION_REQUEST";
export const ASSIGN_BULK_PERMISSION_SUCCESS = "ASSIGN_BULK_PERMISSION_SUCCESS";
export const ASSIGN_BULK_PERMISSION_FAIL = "ASSIGN_BULK_PERMISSION_FAIL";
export const ASSIGN_BULK_PERMISSION_RESET = "ASSIGN_BULK_PERMISSION_RESET";

// Revoke single
export const REVOKE_PERMISSION_REQUEST = "REVOKE_PERMISSION_REQUEST";
export const REVOKE_PERMISSION_SUCCESS = "REVOKE_PERMISSION_SUCCESS";
export const REVOKE_PERMISSION_FAIL = "REVOKE_PERMISSION_FAIL";
export const REVOKE_PERMISSION_RESET = "REVOKE_PERMISSION_RESET";

// Revoke bulk
export const REVOKE_BULK_PERMISSION_REQUEST = "REVOKE_BULK_PERMISSION_REQUEST";
export const REVOKE_BULK_PERMISSION_SUCCESS = "REVOKE_BULK_PERMISSION_SUCCESS";
export const REVOKE_BULK_PERMISSION_FAIL = "REVOKE_BULK_PERMISSION_FAIL";
export const REVOKE_BULK_PERMISSION_RESET = "REVOKE_BULK_PERMISSION_RESET";

// Unassigned
export const UNASSIGNED_PERMISSIONS_REQUEST = "UNASSIGNED_PERMISSIONS_REQUEST";
export const UNASSIGNED_PERMISSIONS_SUCCESS = "UNASSIGNED_PERMISSIONS_SUCCESS";
export const UNASSIGNED_PERMISSIONS_FAIL = "UNASSIGNED_PERMISSIONS_FAIL";
export const UNASSIGNED_PERMISSIONS_RESET = "UNASSIGNED_PERMISSIONS_RESET";

// Unassigned (client)
export const UNASSIGNED_CLIENT_PERMISSIONS_REQUEST = "UNASSIGNED_CLIENT_PERMISSIONS_REQUEST";
export const UNASSIGNED_CLIENT_PERMISSIONS_SUCCESS = "UNASSIGNED_CLIENT_PERMISSIONS_SUCCESS";
export const UNASSIGNED_CLIENT_PERMISSIONS_FAIL = "UNASSIGNED_CLIENT_PERMISSIONS_FAIL";
export const UNASSIGNED_CLIENT_PERMISSIONS_RESET = "UNASSIGNED_CLIENT_PERMISSIONS_RESET";



//roles
export const ROLES_LIST_REQUEST = 'ROLES_LIST_REQUEST';
export const ROLES_LIST_SUCCESS = 'ROLES_LIST_SUCCESS';
export const ROLES_LIST_FAIL = 'ROLES_LIST_FAIL';
export const ROLES_LIST_RESET = 'ROLES_LIST_RESET';



export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAIL = 'PROFILE_UPDATE_FAIL';
export const PROFILE_UPDATE_RESET = 'PROFILE_UPDATE_RESET';

export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL';
export const PASSWORD_CHANGE_RESET = 'PASSWORD_CHANGE_RESET';


//notifications
export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST';
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL';
export const NOTIFICATION_LIST_RESET = 'NOTIFICATION_LIST_RESET';

export const NOTIFICATION_READ_ALL_REQUEST = 'NOTIFICATION_READ_ALL_REQUEST';
export const NOTIFICATION_READ_ALL_SUCCESS = 'NOTIFICATION_READ_ALL_SUCCESS';
export const NOTIFICATION_READ_ALL_FAIL = 'NOTIFICATION_READ_ALL_FAIL';
export const NOTIFICATION_READ_ALL_RESET = 'NOTIFICATION_READ_ALL_RESET'

export const GET_NOTIFICATION_REQUEST = 'GET_NOTIFICATION_REQUEST';
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
export const GET_NOTIFICATION_FAIL = 'GET_NOTIFICATION_FAIL';
export const GET_NOTIFICATION_RESET = 'GET_NOTIFICATION_RESET';

export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS';
export const ADD_NOTIFICATION_FAIL = 'ADD_NOTIFICATION_FAIL';
export const NOTIFICATION_REGISTER_REQUEST = 'NOTIFICATION_REGISTER_REQUEST'
export const NOTIFICATION_REGISTER_RESET = 'NOTIFICATION_REGISTER_RESET'

export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_FAIL = 'DELETE_NOTIFICATION_FAIL';
export const DELETE_NOTIFICATION_RESET = 'PRODUCT_NOTIFICATION_RESET';
export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';

export const NOTIFICATION_DETAILS_SUCCESS = 'NOTIFICATION_DETAILS_SUCCESS';
export const NOTIFICATION_DETAILS_FAIL = 'NOTIFICATION_DETAILS_FAIL';
export const NOTIFICATION_DETAILS_REQUEST = 'NOTIFICATION_DETAILS_REQUEST';

export const NOTIFICATION_UPDATE_REQUEST = 'NOTIFICATION_UPDATE_REQUEST';
export const NOTIFICATION_UPDATE_SUCCESS = 'NOTIFICATION_UPDATE_SUCCESS';
export const NOTIFICATION_UPDATE_FAIL = 'NOTIFICATION_UPDATE_FAIL';
export const NOTIFICATION_UPDATE_RESET = 'NOTIFICATION_UPDATE_RESET';

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';

// Transactions
export const TRANSACTIONS_LIST_REQUEST = 'TRANSACTIONS_LIST_REQUEST';
export const TRANSACTIONS_LIST_SUCCESS = 'TRANSACTIONS_LIST_SUCCESS';
export const TRANSACTIONS_LIST_FAIL = 'TRANSACTIONS_LIST_FAIL';
export const TRANSACTIONS_LIST_RESET = 'TRANSACTIONS_LIST_RESET';

export const TRANSACTION_DETAILS_REQUEST = 'TRANSACTION_DETAILS_REQUEST';
export const TRANSACTION_DETAILS_SUCCESS = 'TRANSACTION_DETAILS_SUCCESS';
export const TRANSACTION_DETAILS_FAIL = 'TRANSACTION_DETAILS_FAIL';
export const TRANSACTION_DETAILS_RESET = 'TRANSACTION_DETAILS_RESET';

export const TRANSACTIONS_SEARCH_REQUEST = 'TRANSACTIONS_SEARCH_REQUEST';
export const TRANSACTIONS_SEARCH_SUCCESS = 'TRANSACTIONS_SEARCH_SUCCESS';
export const TRANSACTIONS_SEARCH_FAIL = 'TRANSACTIONS_SEARCH_FAIL';

export const TRANSACTIONS_PERIOD_REQUEST = 'TRANSACTIONS_PERIOD_REQUEST';
export const TRANSACTIONS_PERIOD_SUCCESS = 'TRANSACTIONS_PERIOD_SUCCESS';
export const TRANSACTIONS_PERIOD_FAIL = 'TRANSACTIONS_PERIOD_FAIL';

export const TRANSACTIONS_PERIOD_STATUS_REQUEST = 'TRANSACTIONS_PERIOD_STATUS_REQUEST';
export const TRANSACTIONS_PERIOD_STATUS_SUCCESS = 'TRANSACTIONS_PERIOD_STATUS_SUCCESS';
export const TRANSACTIONS_PERIOD_STATUS_FAIL = 'TRANSACTIONS_PERIOD_STATUS_FAIL';

export const TRANSACTIONS_METRICS_REQUEST = 'TRANSACTIONS_METRICS_REQUEST';
export const TRANSACTIONS_METRICS_SUCCESS = 'TRANSACTIONS_METRICS_SUCCESS';
export const TRANSACTIONS_METRICS_FAIL = 'TRANSACTIONS_METRICS_FAIL';
export const TRANSACTIONS_METRICS_RESET = 'TRANSACTIONS_METRICS_RESET';

export const TRANSACTIONS_EXPORT_REQUEST = 'TRANSACTIONS_EXPORT_REQUEST';
export const TRANSACTIONS_EXPORT_SUCCESS = 'TRANSACTIONS_EXPORT_SUCCESS';
export const TRANSACTIONS_EXPORT_FAIL = 'TRANSACTIONS_EXPORT_FAIL';
export const TRANSACTIONS_EXPORT_RESET = 'TRANSACTIONS_EXPORT_RESET';




// CURRENCY CONSTANTS
export const CURRENCY_LIST_REQUEST = "CURRENCY_LIST_REQUEST";
export const CURRENCY_LIST_SUCCESS = "CURRENCY_LIST_SUCCESS";
export const CURRENCY_LIST_FAIL = "CURRENCY_LIST_FAIL";

export const CURRENCY_PAGED_REQUEST = "CURRENCY_PAGED_REQUEST";
export const CURRENCY_PAGED_SUCCESS = "CURRENCY_PAGED_SUCCESS";
export const CURRENCY_PAGED_FAIL = "CURRENCY_PAGED_FAIL";

export const CURRENCY_DETAILS_REQUEST = "CURRENCY_DETAILS_REQUEST";
export const CURRENCY_DETAILS_SUCCESS = "CURRENCY_DETAILS_SUCCESS";
export const CURRENCY_DETAILS_FAIL = "CURRENCY_DETAILS_FAIL";

export const CURRENCY_CREATE_REQUEST = "CURRENCY_CREATE_REQUEST";
export const CURRENCY_CREATE_SUCCESS = "CURRENCY_CREATE_SUCCESS";
export const CURRENCY_CREATE_FAIL = "CURRENCY_CREATE_FAIL";
export const CURRENCY_CREATE_RESET = "CURRENCY_CREATE_RESET";

export const CURRENCY_UPDATE_REQUEST = "CURRENCY_UPDATE_REQUEST";
export const CURRENCY_UPDATE_SUCCESS = "CURRENCY_UPDATE_SUCCESS";
export const CURRENCY_UPDATE_FAIL = "CURRENCY_UPDATE_FAIL";
export const CURRENCY_UPDATE_RESET = "CURRENCY_UPDATE_RESET";

export const CURRENCY_DELETE_REQUEST = "CURRENCY_DELETE_REQUEST";
export const CURRENCY_DELETE_SUCCESS = "CURRENCY_DELETE_SUCCESS";
export const CURRENCY_DELETE_FAIL = "CURRENCY_DELETE_FAIL";

// In your Constants/AllConstants.js file, add:

// Orders List
export const ORDERS_LIST_REQUEST = 'ORDERS_LIST_REQUEST';
export const ORDERS_LIST_SUCCESS = 'ORDERS_LIST_SUCCESS';
export const ORDERS_LIST_FAIL = 'ORDERS_LIST_FAIL';
export const ORDERS_LIST_RESET = 'ORDERS_LIST_RESET';

// Order Details
export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';
export const ORDER_DETAILS_RESET = 'ORDER_DETAILS_RESET';

// Order Items
export const ORDER_ITEMS_REQUEST = 'ORDER_ITEMS_REQUEST';
export const ORDER_ITEMS_SUCCESS = 'ORDER_ITEMS_SUCCESS';
export const ORDER_ITEMS_FAIL = 'ORDER_ITEMS_FAIL';

// Order Stats/Dashboard Metrics
export const ORDER_STATS_REQUEST = 'ORDER_STATS_REQUEST';
export const ORDER_STATS_SUCCESS = 'ORDER_STATS_SUCCESS';
export const ORDER_STATS_FAIL = 'ORDER_STATS_FAIL';
export const ORDER_STATS_RESET = 'ORDER_STATS_RESET';

// Complete Order (Cash)
export const ORDER_COMPLETE_REQUEST = 'ORDER_COMPLETE_REQUEST';
export const ORDER_COMPLETE_SUCCESS = 'ORDER_COMPLETE_SUCCESS';
export const ORDER_COMPLETE_FAIL = 'ORDER_COMPLETE_FAIL';
export const ORDER_COMPLETE_RESET = 'ORDER_COMPLETE_RESET';

// User Orders
export const USER_ORDERS_REQUEST = 'USER_ORDERS_REQUEST';
export const USER_ORDERS_SUCCESS = 'USER_ORDERS_SUCCESS';
export const USER_ORDERS_FAIL = 'USER_ORDERS_FAIL';

export const PROCESSING_FEES_LIST_REQUEST = 'PROCESSING_FEES_LIST_REQUEST';
export const PROCESSING_FEES_LIST_SUCCESS = 'PROCESSING_FEES_LIST_SUCCESS';
export const PROCESSING_FEES_LIST_FAIL = 'PROCESSING_FEES_LIST_FAIL';
export const PROCESSING_FEES_LIST_RESET = 'PROCESSING_FEES_LIST_RESET';

export const ORDER_FEES_REQUEST = 'ORDER_FEES_REQUEST';
export const ORDER_FEES_SUCCESS = 'ORDER_FEES_SUCCESS';
export const ORDER_FEES_FAIL = 'ORDER_FEES_FAIL';
export const ORDER_FEES_RESET = 'ORDER_FEES_RESET';


// News Constants
export const NEWS_LIST_REQUEST = 'NEWS_LIST_REQUEST';
export const NEWS_LIST_SUCCESS = 'NEWS_LIST_SUCCESS';
export const NEWS_LIST_FAIL = 'NEWS_LIST_FAIL';
export const NEWS_LIST_RESET = 'NEWS_LIST_RESET';

export const NEWS_DETAILS_REQUEST = 'NEWS_DETAILS_REQUEST';
export const NEWS_DETAILS_SUCCESS = 'NEWS_DETAILS_SUCCESS';
export const NEWS_DETAILS_FAIL = 'NEWS_DETAILS_FAIL';

export const NEWS_CREATE_REQUEST = 'NEWS_CREATE_REQUEST';
export const NEWS_CREATE_SUCCESS = 'NEWS_CREATE_SUCCESS';
export const NEWS_CREATE_FAIL = 'NEWS_CREATE_FAIL';
export const NEWS_CREATE_RESET = 'NEWS_CREATE_RESET';

export const NEWS_UPDATE_REQUEST = 'NEWS_UPDATE_REQUEST';
export const NEWS_UPDATE_SUCCESS = 'NEWS_UPDATE_SUCCESS';
export const NEWS_UPDATE_FAIL = 'NEWS_UPDATE_FAIL';
export const NEWS_UPDATE_RESET = 'NEWS_UPDATE_RESET';

export const NEWS_DELETE_REQUEST = 'NEWS_DELETE_REQUEST';
export const NEWS_DELETE_SUCCESS = 'NEWS_DELETE_SUCCESS';
export const NEWS_DELETE_FAIL = 'NEWS_DELETE_FAIL';
export const NEWS_DELETE_RESET = 'NEWS_DELETE_RESET';

export const NEWS_PUBLISH_REQUEST = 'NEWS_PUBLISH_REQUEST';
export const NEWS_PUBLISH_SUCCESS = 'NEWS_PUBLISH_SUCCESS';
export const NEWS_PUBLISH_FAIL = 'NEWS_PUBLISH_FAIL';
export const NEWS_PUBLISH_RESET = 'NEWS_PUBLISH_RESET';

export const NEWS_BY_STATUS_REQUEST = 'NEWS_BY_STATUS_REQUEST';
export const NEWS_BY_STATUS_SUCCESS = 'NEWS_BY_STATUS_SUCCESS';
export const NEWS_BY_STATUS_FAIL = 'NEWS_BY_STATUS_FAIL';

export const NEWS_BY_CATEGORY_REQUEST = 'NEWS_BY_CATEGORY_REQUEST';
export const NEWS_BY_CATEGORY_SUCCESS = 'NEWS_BY_CATEGORY_SUCCESS';
export const NEWS_BY_CATEGORY_FAIL = 'NEWS_BY_CATEGORY_FAIL';

export const NEWS_FEATURED_REQUEST = 'NEWS_FEATURED_REQUEST';
export const NEWS_FEATURED_SUCCESS = 'NEWS_FEATURED_SUCCESS';
export const NEWS_FEATURED_FAIL = 'NEWS_FEATURED_FAIL';

// Add these constants to your AllConstants.js file

// ==================== LEAGUE CONSTANTS ====================
export const LEAGUE_LIST_REQUEST = 'LEAGUE_LIST_REQUEST';
export const LEAGUE_LIST_SUCCESS = 'LEAGUE_LIST_SUCCESS';
export const LEAGUE_LIST_FAIL = 'LEAGUE_LIST_FAIL';
export const LEAGUE_LIST_RESET = 'LEAGUE_LIST_RESET';

export const LEAGUE_DETAILS_REQUEST = 'LEAGUE_DETAILS_REQUEST';
export const LEAGUE_DETAILS_SUCCESS = 'LEAGUE_DETAILS_SUCCESS';
export const LEAGUE_DETAILS_FAIL = 'LEAGUE_DETAILS_FAIL';

export const LEAGUE_CREATE_REQUEST = 'LEAGUE_CREATE_REQUEST';
export const LEAGUE_CREATE_SUCCESS = 'LEAGUE_CREATE_SUCCESS';
export const LEAGUE_CREATE_FAIL = 'LEAGUE_CREATE_FAIL';
export const LEAGUE_CREATE_RESET = 'LEAGUE_CREATE_RESET';

export const LEAGUE_UPDATE_REQUEST = 'LEAGUE_UPDATE_REQUEST';
export const LEAGUE_UPDATE_SUCCESS = 'LEAGUE_UPDATE_SUCCESS';
export const LEAGUE_UPDATE_FAIL = 'LEAGUE_UPDATE_FAIL';
export const LEAGUE_UPDATE_RESET = 'LEAGUE_UPDATE_RESET';

export const LEAGUE_DELETE_REQUEST = 'LEAGUE_DELETE_REQUEST';
export const LEAGUE_DELETE_SUCCESS = 'LEAGUE_DELETE_SUCCESS';
export const LEAGUE_DELETE_FAIL = 'LEAGUE_DELETE_FAIL';
export const LEAGUE_DELETE_RESET = 'LEAGUE_DELETE_RESET';

export const LEAGUE_BY_SPORT_REQUEST = 'LEAGUE_BY_SPORT_REQUEST';
export const LEAGUE_BY_SPORT_SUCCESS = 'LEAGUE_BY_SPORT_SUCCESS';
export const LEAGUE_BY_SPORT_FAIL = 'LEAGUE_BY_SPORT_FAIL';

export const LEAGUE_BY_COUNTRY_REQUEST = 'LEAGUE_BY_COUNTRY_REQUEST';
export const LEAGUE_BY_COUNTRY_SUCCESS = 'LEAGUE_BY_COUNTRY_SUCCESS';
export const LEAGUE_BY_COUNTRY_FAIL = 'LEAGUE_BY_COUNTRY_FAIL';

export const LEAGUE_ACTIVE_REQUEST = 'LEAGUE_ACTIVE_REQUEST';
export const LEAGUE_ACTIVE_SUCCESS = 'LEAGUE_ACTIVE_SUCCESS';
export const LEAGUE_ACTIVE_FAIL = 'LEAGUE_ACTIVE_FAIL';

export const LEAGUE_TOGGLE_STATUS_REQUEST = 'LEAGUE_TOGGLE_STATUS_REQUEST';
export const LEAGUE_TOGGLE_STATUS_SUCCESS = 'LEAGUE_TOGGLE_STATUS_SUCCESS';
export const LEAGUE_TOGGLE_STATUS_FAIL = 'LEAGUE_TOGGLE_STATUS_FAIL';

export const TOURNAMENT_STATE_REQUEST = 'TOURNAMENT_STATE_REQUEST';
export const TOURNAMENT_STATE_SUCCESS = 'TOURNAMENT_STATE_SUCCESS';
export const TOURNAMENT_STATE_FAIL = 'TOURNAMENT_STATE_FAIL';

export const TOURNAMENT_GROUP_SETUP_REQUEST = 'TOURNAMENT_GROUP_SETUP_REQUEST';
export const TOURNAMENT_GROUP_SETUP_SUCCESS = 'TOURNAMENT_GROUP_SETUP_SUCCESS';
export const TOURNAMENT_GROUP_SETUP_FAIL = 'TOURNAMENT_GROUP_SETUP_FAIL';

export const TOURNAMENT_GROUP_FIXTURES_REQUEST = 'TOURNAMENT_GROUP_FIXTURES_REQUEST';
export const TOURNAMENT_GROUP_FIXTURES_SUCCESS = 'TOURNAMENT_GROUP_FIXTURES_SUCCESS';
export const TOURNAMENT_GROUP_FIXTURES_FAIL = 'TOURNAMENT_GROUP_FIXTURES_FAIL';

export const TOURNAMENT_QUALIFICATION_REQUEST = 'TOURNAMENT_QUALIFICATION_REQUEST';
export const TOURNAMENT_QUALIFICATION_SUCCESS = 'TOURNAMENT_QUALIFICATION_SUCCESS';
export const TOURNAMENT_QUALIFICATION_FAIL = 'TOURNAMENT_QUALIFICATION_FAIL';

export const TOURNAMENT_BRACKET_REQUEST = 'TOURNAMENT_BRACKET_REQUEST';
export const TOURNAMENT_BRACKET_SUCCESS = 'TOURNAMENT_BRACKET_SUCCESS';
export const TOURNAMENT_BRACKET_FAIL = 'TOURNAMENT_BRACKET_FAIL';

export const TOURNAMENT_RECALCULATE_REQUEST = 'TOURNAMENT_RECALCULATE_REQUEST';
export const TOURNAMENT_RECALCULATE_SUCCESS = 'TOURNAMENT_RECALCULATE_SUCCESS';
export const TOURNAMENT_RECALCULATE_FAIL = 'TOURNAMENT_RECALCULATE_FAIL';
export const TOURNAMENT_RESET = 'TOURNAMENT_RESET';

// ==================== TEAM CONSTANTS ====================
export const TEAM_LIST_REQUEST = 'TEAM_LIST_REQUEST';
export const TEAM_LIST_SUCCESS = 'TEAM_LIST_SUCCESS';
export const TEAM_LIST_FAIL = 'TEAM_LIST_FAIL';
export const TEAM_LIST_RESET = 'TEAM_LIST_RESET';

export const TEAM_DETAILS_REQUEST = 'TEAM_DETAILS_REQUEST';
export const TEAM_DETAILS_SUCCESS = 'TEAM_DETAILS_SUCCESS';
export const TEAM_DETAILS_FAIL = 'TEAM_DETAILS_FAIL';

export const TEAM_CREATE_REQUEST = 'TEAM_CREATE_REQUEST';
export const TEAM_CREATE_SUCCESS = 'TEAM_CREATE_SUCCESS';
export const TEAM_CREATE_FAIL = 'TEAM_CREATE_FAIL';
export const TEAM_CREATE_RESET = 'TEAM_CREATE_RESET';

export const TEAM_UPDATE_REQUEST = 'TEAM_UPDATE_REQUEST';
export const TEAM_UPDATE_SUCCESS = 'TEAM_UPDATE_SUCCESS';
export const TEAM_UPDATE_FAIL = 'TEAM_UPDATE_FAIL';
export const TEAM_UPDATE_RESET = 'TEAM_UPDATE_RESET';

export const TEAM_DELETE_REQUEST = 'TEAM_DELETE_REQUEST';
export const TEAM_DELETE_SUCCESS = 'TEAM_DELETE_SUCCESS';
export const TEAM_DELETE_FAIL = 'TEAM_DELETE_FAIL';
export const TEAM_DELETE_RESET = 'TEAM_DELETE_RESET';

export const TEAM_BY_SPORT_REQUEST = 'TEAM_BY_SPORT_REQUEST';
export const TEAM_BY_SPORT_SUCCESS = 'TEAM_BY_SPORT_SUCCESS';
export const TEAM_BY_SPORT_FAIL = 'TEAM_BY_SPORT_FAIL';

export const TEAM_BY_COUNTRY_REQUEST = 'TEAM_BY_COUNTRY_REQUEST';
export const TEAM_BY_COUNTRY_SUCCESS = 'TEAM_BY_COUNTRY_SUCCESS';
export const TEAM_BY_COUNTRY_FAIL = 'TEAM_BY_COUNTRY_FAIL';

export const TEAM_ACTIVE_REQUEST = 'TEAM_ACTIVE_REQUEST';
export const TEAM_ACTIVE_SUCCESS = 'TEAM_ACTIVE_SUCCESS';
export const TEAM_ACTIVE_FAIL = 'TEAM_ACTIVE_FAIL';

export const TEAM_TOGGLE_STATUS_REQUEST = 'TEAM_TOGGLE_STATUS_REQUEST';
export const TEAM_TOGGLE_STATUS_SUCCESS = 'TEAM_TOGGLE_STATUS_SUCCESS';
export const TEAM_TOGGLE_STATUS_FAIL = 'TEAM_TOGGLE_STATUS_FAIL';

// ==================== MATCH CONSTANTS ====================
export const MATCH_LIST_REQUEST = 'MATCH_LIST_REQUEST';
export const MATCH_LIST_SUCCESS = 'MATCH_LIST_SUCCESS';
export const MATCH_LIST_FAIL = 'MATCH_LIST_FAIL';
export const MATCH_LIST_RESET = 'MATCH_LIST_RESET';

export const MATCH_DETAILS_REQUEST = 'MATCH_DETAILS_REQUEST';
export const MATCH_DETAILS_SUCCESS = 'MATCH_DETAILS_SUCCESS';
export const MATCH_DETAILS_FAIL = 'MATCH_DETAILS_FAIL';

export const MATCH_CREATE_REQUEST = 'MATCH_CREATE_REQUEST';
export const MATCH_CREATE_SUCCESS = 'MATCH_CREATE_SUCCESS';
export const MATCH_CREATE_FAIL = 'MATCH_CREATE_FAIL';
export const MATCH_CREATE_RESET = 'MATCH_CREATE_RESET';

export const MATCH_UPDATE_REQUEST = 'MATCH_UPDATE_REQUEST';
export const MATCH_UPDATE_SUCCESS = 'MATCH_UPDATE_SUCCESS';
export const MATCH_UPDATE_FAIL = 'MATCH_UPDATE_FAIL';
export const MATCH_UPDATE_RESET = 'MATCH_UPDATE_RESET';

export const MATCH_DELETE_REQUEST = 'MATCH_DELETE_REQUEST';
export const MATCH_DELETE_SUCCESS = 'MATCH_DELETE_SUCCESS';
export const MATCH_DELETE_FAIL = 'MATCH_DELETE_FAIL';
export const MATCH_DELETE_RESET = 'MATCH_DELETE_RESET';

export const MATCH_BY_STATUS_REQUEST = 'MATCH_BY_STATUS_REQUEST';
export const MATCH_BY_STATUS_SUCCESS = 'MATCH_BY_STATUS_SUCCESS';
export const MATCH_BY_STATUS_FAIL = 'MATCH_BY_STATUS_FAIL';

export const MATCH_BY_LEAGUE_REQUEST = 'MATCH_BY_LEAGUE_REQUEST';
export const MATCH_BY_LEAGUE_SUCCESS = 'MATCH_BY_LEAGUE_SUCCESS';
export const MATCH_BY_LEAGUE_FAIL = 'MATCH_BY_LEAGUE_FAIL';

export const MATCH_BY_TEAM_REQUEST = 'MATCH_BY_TEAM_REQUEST';
export const MATCH_BY_TEAM_SUCCESS = 'MATCH_BY_TEAM_SUCCESS';
export const MATCH_BY_TEAM_FAIL = 'MATCH_BY_TEAM_FAIL';

export const MATCH_BY_DATE_RANGE_REQUEST = 'MATCH_BY_DATE_RANGE_REQUEST';
export const MATCH_BY_DATE_RANGE_SUCCESS = 'MATCH_BY_DATE_RANGE_SUCCESS';
export const MATCH_BY_DATE_RANGE_FAIL = 'MATCH_BY_DATE_RANGE_FAIL';

export const MATCH_LIVE_REQUEST = 'MATCH_LIVE_REQUEST';
export const MATCH_LIVE_SUCCESS = 'MATCH_LIVE_SUCCESS';
export const MATCH_LIVE_FAIL = 'MATCH_LIVE_FAIL';

export const MATCH_UPCOMING_REQUEST = 'MATCH_UPCOMING_REQUEST';
export const MATCH_UPCOMING_SUCCESS = 'MATCH_UPCOMING_SUCCESS';
export const MATCH_UPCOMING_FAIL = 'MATCH_UPCOMING_FAIL';

export const MATCH_PAST_REQUEST = 'MATCH_PAST_REQUEST';
export const MATCH_PAST_SUCCESS = 'MATCH_PAST_SUCCESS';
export const MATCH_PAST_FAIL = 'MATCH_PAST_FAIL';

export const MATCH_FEATURED_REQUEST = 'MATCH_FEATURED_REQUEST';
export const MATCH_FEATURED_SUCCESS = 'MATCH_FEATURED_SUCCESS';
export const MATCH_FEATURED_FAIL = 'MATCH_FEATURED_FAIL';

export const MATCH_UPDATE_SCORE_REQUEST = 'MATCH_UPDATE_SCORE_REQUEST';
export const MATCH_UPDATE_SCORE_SUCCESS = 'MATCH_UPDATE_SCORE_SUCCESS';
export const MATCH_UPDATE_SCORE_FAIL = 'MATCH_UPDATE_SCORE_FAIL';
export const MATCH_UPDATE_SCORE_RESET = 'MATCH_UPDATE_SCORE_RESET';

export const MATCH_UPDATE_STATUS_REQUEST = 'MATCH_UPDATE_STATUS_REQUEST';
export const MATCH_UPDATE_STATUS_SUCCESS = 'MATCH_UPDATE_STATUS_SUCCESS';
export const MATCH_UPDATE_STATUS_FAIL = 'MATCH_UPDATE_STATUS_FAIL';
export const MATCH_UPDATE_STATUS_RESET = 'MATCH_UPDATE_STATUS_RESET';

export const MATCH_STATISTICS_REQUEST = 'MATCH_STATISTICS_REQUEST';
export const MATCH_STATISTICS_SUCCESS = 'MATCH_STATISTICS_SUCCESS';
export const MATCH_STATISTICS_FAIL = 'MATCH_STATISTICS_FAIL';

export const ZONE_CONFIG_CREATE_REQUEST = 'ZONE_CONFIG_CREATE_REQUEST';
export const ZONE_CONFIG_CREATE_SUCCESS = 'ZONE_CONFIG_CREATE_SUCCESS';
export const ZONE_CONFIG_CREATE_FAIL = 'ZONE_CONFIG_CREATE_FAIL';
export const ZONE_CONFIG_CREATE_RESET = 'ZONE_CONFIG_CREATE_RESET';

export const ZONE_CONFIG_LIST_REQUEST = 'ZONE_CONFIG_LIST_REQUEST';
export const ZONE_CONFIG_LIST_SUCCESS = 'ZONE_CONFIG_LIST_SUCCESS';
export const ZONE_CONFIG_LIST_FAIL = 'ZONE_CONFIG_LIST_FAIL';
export const ZONE_CONFIG_LIST_RESET = 'ZONE_CONFIG_LIST_RESET';

export const ZONE_CONFIG_UPDATE_REQUEST = 'ZONE_CONFIG_UPDATE_REQUEST';
export const ZONE_CONFIG_UPDATE_SUCCESS = 'ZONE_CONFIG_UPDATE_SUCCESS';
export const ZONE_CONFIG_UPDATE_FAIL = 'ZONE_CONFIG_UPDATE_FAIL';
export const ZONE_CONFIG_UPDATE_RESET = 'ZONE_CONFIG_UPDATE_RESET';

export const ZONE_CONFIG_DELETE_REQUEST = 'ZONE_CONFIG_DELETE_REQUEST';
export const ZONE_CONFIG_DELETE_SUCCESS = 'ZONE_CONFIG_DELETE_SUCCESS';
export const ZONE_CONFIG_DELETE_FAIL = 'ZONE_CONFIG_DELETE_FAIL';
export const ZONE_CONFIG_DELETE_RESET = 'ZONE_CONFIG_DELETE_RESET';

export const ZONE_INITIALIZE_AFRICAN_REQUEST = 'ZONE_INITIALIZE_AFRICAN_REQUEST';
export const ZONE_INITIALIZE_AFRICAN_SUCCESS = 'ZONE_INITIALIZE_AFRICAN_SUCCESS';
export const ZONE_INITIALIZE_AFRICAN_FAIL = 'ZONE_INITIALIZE_AFRICAN_FAIL';
export const ZONE_INITIALIZE_AFRICAN_RESET = 'ZONE_INITIALIZE_AFRICAN_RESET';

export const ZONE_INITIALIZE_CUSTOM_REQUEST = 'ZONE_INITIALIZE_CUSTOM_REQUEST';
export const ZONE_INITIALIZE_CUSTOM_SUCCESS = 'ZONE_INITIALIZE_CUSTOM_SUCCESS';
export const ZONE_INITIALIZE_CUSTOM_FAIL = 'ZONE_INITIALIZE_CUSTOM_FAIL';
export const ZONE_INITIALIZE_CUSTOM_RESET = 'ZONE_INITIALIZE_CUSTOM_RESET';

export const ZONE_APPLY_TO_STANDINGS_REQUEST = 'ZONE_APPLY_TO_STANDINGS_REQUEST';
export const ZONE_APPLY_TO_STANDINGS_SUCCESS = 'ZONE_APPLY_TO_STANDINGS_SUCCESS';
export const ZONE_APPLY_TO_STANDINGS_FAIL = 'ZONE_APPLY_TO_STANDINGS_FAIL';
export const ZONE_APPLY_TO_STANDINGS_RESET = 'ZONE_APPLY_TO_STANDINGS_RESET';

export const ZONE_QUICK_SETUP_REQUEST = 'ZONE_QUICK_SETUP_REQUEST';
export const ZONE_QUICK_SETUP_SUCCESS = 'ZONE_QUICK_SETUP_SUCCESS';
export const ZONE_QUICK_SETUP_FAIL = 'ZONE_QUICK_SETUP_FAIL';
export const ZONE_QUICK_SETUP_RESET = 'ZONE_QUICK_SETUP_RESET';

export const ZONE_FOR_POSITION_REQUEST = 'ZONE_FOR_POSITION_REQUEST';
export const ZONE_FOR_POSITION_SUCCESS = 'ZONE_FOR_POSITION_SUCCESS';
export const ZONE_FOR_POSITION_FAIL = 'ZONE_FOR_POSITION_FAIL';

// Get league standings
export const STANDING_LEAGUE_LIST_REQUEST = 'STANDING_LEAGUE_LIST_REQUEST';
export const STANDING_LEAGUE_LIST_SUCCESS = 'STANDING_LEAGUE_LIST_SUCCESS';
export const STANDING_LEAGUE_LIST_FAIL = 'STANDING_LEAGUE_LIST_FAIL';
export const STANDING_LEAGUE_LIST_RESET = 'STANDING_LEAGUE_LIST_RESET';

// Get team standings
export const STANDING_TEAM_LIST_REQUEST = 'STANDING_TEAM_LIST_REQUEST';
export const STANDING_TEAM_LIST_SUCCESS = 'STANDING_TEAM_LIST_SUCCESS';
export const STANDING_TEAM_LIST_FAIL = 'STANDING_TEAM_LIST_FAIL';
export const STANDING_TEAM_LIST_RESET = 'STANDING_TEAM_LIST_RESET';

// Get standing details
export const STANDING_DETAILS_REQUEST = 'STANDING_DETAILS_REQUEST';
export const STANDING_DETAILS_SUCCESS = 'STANDING_DETAILS_SUCCESS';
export const STANDING_DETAILS_FAIL = 'STANDING_DETAILS_FAIL';

// Create standing
export const STANDING_CREATE_REQUEST = 'STANDING_CREATE_REQUEST';
export const STANDING_CREATE_SUCCESS = 'STANDING_CREATE_SUCCESS';
export const STANDING_CREATE_FAIL = 'STANDING_CREATE_FAIL';
export const STANDING_CREATE_RESET = 'STANDING_CREATE_RESET';

// Update standing
export const STANDING_UPDATE_REQUEST = 'STANDING_UPDATE_REQUEST';
export const STANDING_UPDATE_SUCCESS = 'STANDING_UPDATE_SUCCESS';
export const STANDING_UPDATE_FAIL = 'STANDING_UPDATE_FAIL';
export const STANDING_UPDATE_RESET = 'STANDING_UPDATE_RESET';

// Delete standing
export const STANDING_DELETE_REQUEST = 'STANDING_DELETE_REQUEST';
export const STANDING_DELETE_SUCCESS = 'STANDING_DELETE_SUCCESS';
export const STANDING_DELETE_FAIL = 'STANDING_DELETE_FAIL';
export const STANDING_DELETE_RESET = 'STANDING_DELETE_RESET';

// Initialize standings
export const STANDING_INITIALIZE_REQUEST = 'STANDING_INITIALIZE_REQUEST';
export const STANDING_INITIALIZE_SUCCESS = 'STANDING_INITIALIZE_SUCCESS';
export const STANDING_INITIALIZE_FAIL = 'STANDING_INITIALIZE_FAIL';

// Recalculate standings
export const STANDING_RECALCULATE_REQUEST = 'STANDING_RECALCULATE_REQUEST';
export const STANDING_RECALCULATE_SUCCESS = 'STANDING_RECALCULATE_SUCCESS';
export const STANDING_RECALCULATE_FAIL = 'STANDING_RECALCULATE_FAIL';

// Get relegation zone
export const STANDING_RELEGATION_REQUEST = 'STANDING_RELEGATION_REQUEST';
export const STANDING_RELEGATION_SUCCESS = 'STANDING_RELEGATION_SUCCESS';
export const STANDING_RELEGATION_FAIL = 'STANDING_RELEGATION_FAIL';

// Get promotion zone
export const STANDING_PROMOTION_REQUEST = 'STANDING_PROMOTION_REQUEST';
export const STANDING_PROMOTION_SUCCESS = 'STANDING_PROMOTION_SUCCESS';
export const STANDING_PROMOTION_FAIL = 'STANDING_PROMOTION_FAIL';

// Get top teams
export const STANDING_TOP_TEAMS_REQUEST = 'STANDING_TOP_TEAMS_REQUEST';
export const STANDING_TOP_TEAMS_SUCCESS = 'STANDING_TOP_TEAMS_SUCCESS';
export const STANDING_TOP_TEAMS_FAIL = 'STANDING_TOP_TEAMS_FAIL';

// Update standing statuses
export const STANDING_UPDATE_STATUSES_REQUEST = 'STANDING_UPDATE_STATUSES_REQUEST';
export const STANDING_UPDATE_STATUSES_SUCCESS = 'STANDING_UPDATE_STATUSES_SUCCESS';
export const STANDING_UPDATE_STATUSES_FAIL = 'STANDING_UPDATE_STATUSES_FAIL';


// Get league teams
export const TEAM_LEAGUE_LIST_REQUEST = 'TEAM_LEAGUE_LIST_REQUEST';
export const TEAM_LEAGUE_LIST_SUCCESS = 'TEAM_LEAGUE_LIST_SUCCESS';
export const TEAM_LEAGUE_LIST_FAIL = 'TEAM_LEAGUE_LIST_FAIL';
export const TEAM_LEAGUE_LIST_RESET = 'TEAM_LEAGUE_LIST_RESET';

// Get team leagues
export const LEAGUE_TEAM_LIST_REQUEST = 'LEAGUE_TEAM_LIST_REQUEST';
export const LEAGUE_TEAM_LIST_SUCCESS = 'LEAGUE_TEAM_LIST_SUCCESS';
export const LEAGUE_TEAM_LIST_FAIL = 'LEAGUE_TEAM_LIST_FAIL';

// Add team to league
export const TEAM_LEAGUE_ADD_REQUEST = 'TEAM_LEAGUE_ADD_REQUEST';
export const TEAM_LEAGUE_ADD_SUCCESS = 'TEAM_LEAGUE_ADD_SUCCESS';
export const TEAM_LEAGUE_ADD_FAIL = 'TEAM_LEAGUE_ADD_FAIL';
export const TEAM_LEAGUE_ADD_RESET = 'TEAM_LEAGUE_ADD_RESET';

// Remove team from league
export const TEAM_LEAGUE_REMOVE_REQUEST = 'TEAM_LEAGUE_REMOVE_REQUEST';
export const TEAM_LEAGUE_REMOVE_SUCCESS = 'TEAM_LEAGUE_REMOVE_SUCCESS';
export const TEAM_LEAGUE_REMOVE_FAIL = 'TEAM_LEAGUE_REMOVE_FAIL';
export const TEAM_LEAGUE_REMOVE_RESET = 'TEAM_LEAGUE_REMOVE_RESET';

// Get league divisions
export const LEAGUE_DIVISIONS_REQUEST = 'LEAGUE_DIVISIONS_REQUEST';
export const LEAGUE_DIVISIONS_SUCCESS = 'LEAGUE_DIVISIONS_SUCCESS';
export const LEAGUE_DIVISIONS_FAIL = 'LEAGUE_DIVISIONS_FAIL';
